<mat-form-field
  class="w-full text-project-50"
  [ngClass]="{
    'on-error': control.hasError('required'),
    'mention-flash': isFlashed
  }"
  [appearance]="'outline'"
>
  <input
    type="text"
    matInput
    [name]="'Headline'"
    [formControl]="control"
    placeholder="Headline"
    class="font-bold text-project-1400"
  />
</mat-form-field>
